import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BEElectricalComputerCoursePage: React.FC = () => {
  const courseData = {
    title: "B.E. Electrical and Computer Engineering",
    shortName: "B.E. ECE",
    duration: "4 years",
    description: "Interdisciplinary engineering program combining electrical engineering with computer systems and digital technologies",
    overview: "Bachelor of Engineering in Electrical and Computer Engineering (B.E. ECE) is a 4-year undergraduate program that bridges electrical engineering and computer engineering. This course covers digital systems, embedded systems, computer architecture, power electronics, signal processing, and computer networks, preparing students for careers at the intersection of electrical and computer technologies.",
    eligibility: [
      "10+2 with Physics, Chemistry, Mathematics",
      "Minimum 75% marks in JEE Main (50% for SC/ST)",
      "Valid JEE Main/State CET scores",
      "Interest in both electrical and computer systems"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Mathematics-I & II",
          "Physics",
          "Chemistry",
          "Engineering Graphics",
          "Programming Fundamentals",
          "Digital Logic Design"
        ]
      },
      {
        year: 2,
        subjects: [
          "Circuit Analysis",
          "Computer Organization",
          "Data Structures",
          "Electronic Devices",
          "Signals and Systems",
          "Discrete Mathematics"
        ]
      },
      {
        year: 3,
        subjects: [
          "Microprocessors and Microcontrollers",
          "Computer Architecture",
          "Digital Signal Processing",
          "Power Electronics",
          "Operating Systems",
          "Embedded Systems"
        ]
      },
      {
        year: 4,
        subjects: [
          "Computer Networks",
          "VLSI Design",
          "Real-time Systems",
          "Machine Learning for Engineers",
          "Project Work",
          "Industrial Training"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Embedded Systems Engineer",
        "Hardware Design Engineer",
        "Software Engineer",
        "VLSI Design Engineer",
        "Systems Engineer",
        "Computer Hardware Engineer",
        "Signal Processing Engineer",
        "Network Engineer",
        "R&D Engineer",
        "Technical Consultant"
      ],
      industries: [
        "Semiconductor Industry",
        "Computer Hardware Manufacturing",
        "Telecommunications",
        "Automotive Electronics",
        "Aerospace Industry",
        "Consumer Electronics",
        "Software Development",
        "Research Institutions",
        "Defense Organizations",
        "Startup Companies"
      ],
      averageSalary: "₹5-10 LPA (Fresher), ₹15-40 LPA (Experienced)",
      topRecruiters: [
        "Intel, Qualcomm, Broadcom",
        "TCS, Infosys, Wipro",
        "Texas Instruments, Analog Devices",
        "Samsung, LG Electronics",
        "Google, Microsoft, Amazon",
        "DRDO, ISRO"
      ]
    },

    admissionProcess: [
      "TNEA Counselling (for Tamil Nadu colleges)",
      "JEE Main (for NITs and central universities)",
      "State-level entrance exams",
      "Management quota admissions",
      "Direct admission based on 12th marks"
    ],

    topColleges: [
      {
        name: "Indian Institute of Technology",
        location: "Various locations",
        fees: "₹8,50,000",
        ranking: "NIRF Ranking: Top 10"
      },
      {
        name: "National Institute of Technology",
        location: "Various locations",
        fees: "₹6,50,000",
        ranking: "NIRF Ranking: 15-30"
      },
      {
        name: "VIT University",
        location: "Vellore",
        fees: "₹7,83,000",
        ranking: "NIRF Ranking: 15"
      },
      {
        name: "SRM Institute of Science and Technology",
        location: "Chennai",
        fees: "₹12,00,000",
        ranking: "NIRF Ranking: 41"
      }
    ],

    skills: [
      "Digital System Design",
      "Embedded Programming",
      "Computer Architecture",
      "Signal Processing",
      "VLSI Design",
      "Network Protocols",
      "Real-time Systems",
      "Machine Learning",
      "Hardware-Software Integration",
      "System Optimization"
    ],

    futureScope: "Excellent prospects with IoT, AI hardware, autonomous systems, quantum computing, and edge computing creating high demand for electrical-computer engineering expertise.",

    faqs: [
      {
        question: "What makes ECE different from traditional EEE or CSE?",
        answer: "ECE combines electrical engineering foundations with computer systems expertise, focusing on hardware-software integration, embedded systems, and digital technologies."
      },
      {
        question: "Can I work in both hardware and software roles?",
        answer: "Yes, ECE graduates are uniquely positioned to work in embedded systems, hardware design, firmware development, and system-level software roles."
      },
      {
        question: "What are the opportunities in emerging technologies?",
        answer: "Excellent opportunities in IoT, autonomous vehicles, robotics, AI hardware, smart devices, and edge computing where electrical and computer expertise converge."
      },
      {
        question: "Is this suitable for students interested in both electrical and computers?",
        answer: "Absolutely! This program is ideal for students who want to work at the intersection of electrical systems and computer technologies."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BEElectricalComputerCoursePage;
